import { render, staticRenderFns } from "./FullCalendar.vue?vue&type=template&id=f2b66f5a&scoped=true&"
import script from "./FullCalendar.vue?vue&type=script&lang=js&"
export * from "./FullCalendar.vue?vue&type=script&lang=js&"
import style0 from "./FullCalendar.vue?vue&type=style&index=0&id=f2b66f5a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2b66f5a",
  null
  
)

export default component.exports